// extracted by mini-css-extract-plugin
export default {"disableLink":"_k-z"};